"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
/**
 * @react-component TextInput - basic styling and behavior for inputs that can be used directly or built upon if it
 * needs to support additional functionality
 */
var TextInput = /** @class */ (function (_super) {
    tslib_1.__extends(TextInput, _super);
    function TextInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.state = { hasFocus: false };
        return _this;
    }
    TextInput.prototype.setState = function (state) {
        this.state = state;
    };
    /**
     * @function onInputFocus - fires `onFocus` handler passed to it, if it exists, and updates focus state value
     * @param event
     */
    TextInput.prototype.onInputFocus = function (event) {
        this.setState({ hasFocus: true });
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    };
    /**
     * @function onInputBlur - fires `onBlur` handler passed to it, if it exists, and updates focus state value
     * @param event
     */
    TextInput.prototype.onInputBlur = function (event) {
        this.setState({ hasFocus: false });
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    };
    /**
     * @function getCssClassList - formats CSS class list
     * @returns {string}
     */
    TextInput.prototype.getCssClassList = function () {
        var defaultClassName = 'vx_form-group vx_floatingLabel_active';
        // maintain the `hasValue` state when field has content or field is focused
        if (this.props.defaultValue || this.state.hasFocus) {
            defaultClassName += ' hasValue';
        }
        // show errors after user has interacted with field
        if (this.props.hasError && this.props.isDirty) {
            defaultClassName += this.props.errorMessage ?
                ' vx_has-error-with-message' :
                ' vx_has-error';
            // if we've got an info message, show it
        }
        else if (this.props.infoMessage && this.state.hasFocus) {
            defaultClassName += ' vx_has-message';
        }
        return defaultClassName;
    };
    TextInput.prototype.render = function () {
        var _this = this;
        var showError = this.props.hasError && this.props.isDirty, showInfo = !showError && this.props.infoMessage && this.state.hasFocus;
        return (React.createElement("div", { className: this.getCssClassList(), "data-label-content": this.props.label },
            React.createElement("label", { htmlFor: this.props.id }, this.props.label),
            React.createElement("div", { className: 'vx_form-control vx_form-control_complex' },
                React.createElement("input", { type: 'text', id: this.props.id, name: this.props.name || this.props.id, defaultValue: this.props.defaultValue, placeholder: this.props.placeholder, onChange: this.props.onChange, onBlur: function (e) { return _this.onInputBlur(e); }, onFocus: function (e) { return _this.onInputFocus(e); }, ref: function (input) {
                        if (input && _this.props.clearValue) {
                            input.value = '';
                        }
                    } })),
            showError && this.props.errorMessage ?
                React.createElement("span", { className: 'vx_form-control-message' }, this.props.errorMessage) :
                null,
            showInfo ?
                React.createElement("span", { className: 'vx_form-control-message' }, this.props.infoMessage) :
                null));
    };
    return TextInput;
}(React.Component));
exports.default = TextInput;
